// @ts-nocheck
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface TagHeaderProps {
  bulkChangeTag: (e: unknown) => void;
  tagsAsFreeText: boolean;
  requesterTags: unknown[];
  bulkTag?: string;
  bulkTagOnBlur: () => void;
}

function TagHeader({
  bulkChangeTag,
  tagsAsFreeText,
  requesterTags,
  bulkTag,
  bulkTagOnBlur,
}: TagHeaderProps) {
  const { t } = useTranslation();
  return (
    <div className="bulk-grid-game-name-th hidden-input">
      <span className="mb-2">{t('Tag')}</span>
      {tagsAsFreeText ? (
        <input
          type="text"
          className="form-control apply"
          onChange={bulkChangeTag}
          value={bulkTag || ''}
          onBlur={bulkTagOnBlur}
          placeholder={t('Apply to all')}
        ></input>
      ) : (
        <select
          className="form-control apply"
          value={bulkTag || ''}
          onChange={(e) => {
            bulkChangeTag(e);
          }}
        >
          <option value="">{t('Apply to all')}</option>
          {requesterTags &&
            [...requesterTags]
              ?.sort((a, b) => a.tag.localeCompare(b.tag))
              ?.map((x) => (
                <option key={x.id} value={x.id}>
                  {x.tag}
                </option>
              ))}
        </select>
      )}
    </div>
  );
}

export default TagHeader;
